import useEntity from "../../hooks/useContractorUser";
import ContractorUserDetail from "../../components/contractorUser/ContractorUserDetail/ContractorUserDetail";
import ContractorUserScoped from "../../components/contractorUser/ContractorUserDetail/ContractorUserScoped";
import ContractorUserTabs from "../../components/contractorUser/ContractorUserDetail/ContractorUserTabs";
import { useGetContractorUserQuery } from "../../apis/ContractorUser.api";
import { PrimaryContractorUser } from "../../types/models/ContractorUser";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorUserDetailPage = () => {

    useTitle(t`Details Contractor User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { contractorUserId: id } = useParams();

    const { data, refetch } = useGetContractorUserQuery(PrimaryContractorUser.fromPath(id))
    const { deleteContractorUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteContractorUser(data, '..')
    }, [data, deleteContractorUser])

    if (id === 'scoped') {
        return (<ContractorUserScoped/>)
    }

    return (
        <Box data-testid="ContractorUser-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ContractorUserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ContractorUsers/update/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/ContractorUsers/update/view'
        ) ||
session.hasPermission(
            data.contractorUserScopeGroupId,
            'applications/timber/entities/ContractorUsers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="ContractorUser-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ContractorUsers/delete/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/ContractorUsers/delete/view'
        ) ||
session.hasPermission(
            data.contractorUserScopeGroupId,
            'applications/timber/entities/ContractorUsers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="ContractorUser-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ContractorUserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ContractorUserDetailPage;
